import { Stack } from "@mui/material";

import { IgTypography } from "@intelligems/ig-theme/IgTypography";

import { CreateRuleForm, type CreateRuleFormProps } from "./CreateRuleForm";

export type CreateRuleTabEmbeddedViewProps = Omit<
  CreateRuleFormProps,
  "composerSurface" | "templatesHeading" | "templateCardSize"
>;

/**
 * The creation view as it appears inside a host that has been taken over — an
 * upsell's settings, the onsite builder.
 *
 * The Atlas rail is already open beside it here, so the form drops its own
 * composer and the heading points at the one that is on screen; what is left
 * is the template gallery, which the rail cannot offer.
 */
export const CreateRuleTabEmbeddedView = (
  formProps: CreateRuleTabEmbeddedViewProps
) => (
  <Stack spacing={3}>
    <Stack spacing={1}>
      <IgTypography component="h1" variant="h3" fontWeight={600}>
        New rule
      </IgTypography>
      <IgTypography color="text.secondary">
        Tell Atlas what you want on the right — or start from a template below.
      </IgTypography>
    </Stack>
    <CreateRuleForm
      {...formProps}
      composerSurface="none"
      templatesHeading={null}
      // Three across, as the gallery reads beside the rail: the full-page
      // surface fits five, but half that width here would give five slivers.
      templateCardSize={{ xs: 10, sm: 5, lg: 3 }}
    />
  </Stack>
);
